/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderColor: '#bdc3c7',
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderColor: '#bdc3c7',
    backgroundColor: '#f8f9fa',
    padding: 5,
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderColor: '#bdc3c7',
    padding: 5,
  },
  tableCellHeader: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#34495e',
  },
  tableCell: {
    fontSize: 9,
    color: '#2c3e50',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },
 
  note: {
    fontSize: 8,
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginTop: 5,
  }
});

const ExportPDFAuthorisationEAFdw = ({ user, data,agencyInfo }) => {


  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
       <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Authorisation for EA for FDW</Text>
        
        {/* Declaration by Employer */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Declaration by Employer</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Name:</Text>
              <Text style={styles.value}>{data.employerName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>NRIC / FIN:</Text>
              <Text style={styles.value}>{data.employerNric || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Contact No.:</Text>
              <Text style={styles.value}>{data.employerContact || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Signature & Date:</Text>
              <Text style={styles.value}>{data.employerSignature || ''}</Text>
            </View>
          </View>
        </View>

        {/* Foreign Domestic Worker(s) Table */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Foreign Domestic Worker(s)</Text>
          
          {/* Table Header */}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>S/N</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Name of FDW</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Passport / FIN / WP No.</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Authorised Transaction</Text>
              </View>
            </View>
            
            {/* Table Row 1 */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>1</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw1Name || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw1Id || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw1Txn || 'Not specified'}</Text>
              </View>
            </View>
            
            {/* Table Row 2 */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>2</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw2Name || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw2Id || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.fdw2Txn || 'Not specified'}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Authorisation of EA */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Authorisation of EA</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>I hereby authorise:</Text>
              <Text style={styles.value}>{data.eaNameLicence || 'Not specified'}</Text>
              <Text style={styles.note}>Name and licence no. of EA to perform the above work pass transaction(s) on my behalf.</Text>
            </View>
          </View>
          
          {(data.repName || data.repId) && (
            <View style={styles.row}>
              <View style={styles.column}>
                <Text style={styles.label}>If applicable, I hereby authorise:</Text>
                <Text style={styles.value}>{data.repName || 'Not specified'}</Text>
                <Text style={styles.label}>Representative NRIC/Passport No.:</Text>
                <Text style={styles.value}>{data.repId || 'Not specified'}</Text>
                <Text style={styles.note}>A copy of the representative&apos;s NRIC/Passport must be enclosed.</Text>
              </View>
            </View>
          )}
        </View>

        {/* Declaration by EA */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Declaration by EA</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Name of EA Personnel:</Text>
              <Text style={styles.value}>{data.eaPersonnel || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Registration No.:</Text>
              <Text style={styles.value}>{data.eaRegNo || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Signature & Date:</Text>
              <Text style={styles.value}>{data.eaSignature || ''}</Text>
            </View>
          </View>
          <Text style={styles.note}>
            I declare that I have verified the authorisation with the employer, confirmed any representative, 
            and ensured all required fields are completed before processing.
          </Text>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Authorisation for EA for FDW Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFAuthorisationEAFdw;
